import { render, staticRenderFns } from "./SpacFaq.vue?vue&type=template&id=5f0ea07c"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VueSimpleAccordion: require('/vercel/path0/components/VueSimpleAccordion.vue').default})
